import { render } from "./ProductRecommendationsToggle.vue?vue&type=template&id=3d9a6faa&scoped=true"
import script from "./ProductRecommendationsToggle.vue?vue&type=script&lang=js"
export * from "./ProductRecommendationsToggle.vue?vue&type=script&lang=js"

import "./ProductRecommendationsToggle.vue?vue&type=style&index=0&id=3d9a6faa&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d9a6faa"]])

export default __exports__